<template>
  <div class="develop-week panel tile-shadow panel-default" :class="{ expanded: expanded }">
    <div class="panel-body">
      <h3
        @click="handleWeekClick()"
        @keydown.space="handleWeekClick()"
        class="week-title"
        style="margin: 0; padding: 20px"
      >
        {{ model.title }}
      </h3>
      <span class="expansion-toggle">{{ expanded ? "-" : "+" }}</span>
      <div class="develop-week-step-wrapper">
        <div
          class="develop-step"
          @click="handleStepClick(step)"
          @keydown.space="handleStepClick(step)"
          :class="{
            completed: step.isComplete,
            available: step.isAvailable,
            current: step.isCurrent,
          }"
          :data-test="step.isCurrent ? 'current-develop-step' : 'develop-step'"
          v-for="step in model.steps"
          :key="step.id"
        >
          <span v-if="step.isComplete" class="step-completion-icon glyphicon glyphicon-ok"></span>
          <span v-else class="step-completion-icon">&bullet;</span>
          <StepIcon
            :day-or-page-type="step.dayOrPageType"
            :is-available="step.isAvailable"
            :is-current="step.isCurrent"
          />
          <div class="step-text">
            <span class="step-title">{{ step.title }}</span>
            <span class="step-subtitle">{{ step.subtitle }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { debug as d } from "debug";
import { PlanStepModel, PlanWeekModel } from "./develop-plan-models";
import StepIcon from "./step-icon.vue";

const debug = d("cs.DevelopWeek");

const props = withDefaults(
  defineProps<{
    model: PlanWeekModel;
    expanded: boolean;
  }>(),
  {
    expanded: false,
  },
);

const emit = defineEmits(["expand", "contract"]);

function handleWeekClick(): void {
  debug("handleClick", props.expanded);
  if (!props.expanded) {
    emit("expand");
  } else {
    emit("contract");
  }
}

function handleStepClick(step: PlanStepModel): void {
  if (step.isAvailable) {
    window.location.href = `/resources/develop/${step.uid}`;
  }
}
</script>

<style scoped lang="less">
@import (reference) "../../styles/bootstrap/variables.less";

.panel-body {
  padding: 0;
  border: 1px solid lightgray;
}

.week-title {
  cursor: pointer;
  border-bottom: 1px solid lightgray;
  background-color: #f8f8f8;
}

.develop-week-step-wrapper {
  overflow: hidden;
}

.develop-week .develop-week-step-wrapper {
  max-height: 0;
}

.develop-week.expanded .develop-week-step-wrapper {
  max-height: 80em;
}

.develop-step {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;

  &:hover {
    background-color: #eee;
  }

  &:not(.available):hover {
    background-color: #fafafa;
  }

  &.available {
    cursor: pointer;
  }

  &.current {
    background-color: lighten(@brand-primary, 48%);
    color: @brand-primary;
  }

  &.current:hover {
    background-color: lighten(@brand-primary, 45%);
  }
}

.expansion-toggle {
  display: block;
  position: absolute;
  top: 12px;
  right: 48px;
  font-size: 30px;
  font-weight: bolder;
  pointer-events: none;
  user-select: none;
}

.step-completion-icon {
  display: inline-block;
  margin: 20px 10px;
  margin-left: 20px;
}

.develop-step.completed .step-completion-icon {
  color: green;
}

.step-icon {
  width: 50px;
  min-width: 50px;
  min-height: 50px;
  margin: 20px 20px;
}

.step-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  user-select: none;

  .step-title {
    font-weight: bold;
  }
}
</style>
